import React, { useEffect, useState } from 'react';

import { Button, Row, Col, Form, Tab, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import DaumPostcode from 'react-daum-postcode';
import Swal from 'sweetalert2';

import { editConfiguration } from 'apis/admin/configApi';

function CompanyInfo({
  tabEventKey,
  configData,
  getAllConfiguration,
}) {
  const [show, setShow] = useState(false);  // 다음 우편번호 찾기 모달 여닫는 state

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onSubmit',
  });

  // react-hook-form에 기본 값 설정하기
  useEffect(() => {
    if (configData) {
      for (const key in configData) {
        setValue(key, configData[key]);
      }
    }
  }, [configData]);

  // 사업장 주소 입력
  const handleComplete = (data) => {
    let fullAddress = data.address;
    // let extraAddress = '';

    // if (data.addressType === 'R') {
    //   if (data.bname !== '') {
    //     extraAddress += data.bname;
    //   }
    //   if (data.buildingName !== '') {
    //     extraAddress +=
    //       extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
    //   }
    //   fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    // }

    setValue('company_zipcode', data.zonecode);
    setValue('company_address', fullAddress);

    setShow(false);
  };

  // 환경 설정 - 회사 정보 설정 저장
  const onSubmit = async (data) => {
    let dataToSubmit = data;
    for (const key in dataToSubmit) {
      if (isNaN(dataToSubmit[key]) && dataToSubmit[key] !== '') {
        dataToSubmit[key] = dataToSubmit[key].trim();
      }
    }
    
    await editConfiguration(dataToSubmit)
      .then(async (response) => {
        if (response.data.success) {
          Swal.fire({
            icon: 'success',
            title: '환경 설정 저장을 완료했습니다.',
          }).then(async () => {
            await getAllConfiguration();
          });
        }
        else {
          Swal.fire({
            icon: 'error',
            title: '환경 설정을 저장할 수 없습니다.',
            text: '잠시 후 다시 시도해주세요.',
          }).then(() => {
            return;
          });
        }
      })
      .catch(error => {
        console.error('error occured in BasicConfig/CompanyInfo.js - onSubmit() ', error);

        Swal.fire({
          icon: 'error',
          title: '환경 설정을 저장할 수 없습니다.',
          text: '잠시 후 다시 시도해주세요.',
        }).then(() => {
          return;
        });
      });
  };

  return (
    <Tab.Pane eventKey={tabEventKey}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            회사명
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              type="text"
              {...register('company_name')}
              isInvalid={errors.company_name}
            />
            <Form.Control.Feedback type="invalid">
              {errors.company_name && errors.company_name.message}
            </Form.Control.Feedback>
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            사업자등록번호
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              type="text"
              {...register('company_reg_no')}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            대표자명
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              type="text"
              {...register('company_owner')}
              isInvalid={errors.company_owner}
            />
            <Form.Control.Feedback type="invalid">
              {errors.company_owner && errors.company_owner.message}
            </Form.Control.Feedback>
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            대표전화번호
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              type="text"
              {...register('company_phone')}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            팩스번호
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              type="text"
              {...register('company_fax')}
            />
          </Col>
        </Form.Group>
        {/* <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            통신판매업신고번호
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              type="text"
              {...register('company_retail_sale_no')}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            부가통신 사업자번호
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              type="text"
              {...register('company_added_sale_no')}
            />
          </Col>
        </Form.Group> */}
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            사업장 우편번호
          </Form.Label>
          <Col sm={3}>
            <Form.Control
              type="text"
              {...register('company_zipcode')}
              onClick={() => setShow(true)}
            />
          </Col>
          <Col sm={2}>
            <Button variant="primary" onClick={() => setShow(true)}>주소 찾기</Button>
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            사업장 주소
          </Form.Label>
          <Col>
            <Form.Control
              type="text"
              {...register('company_address')}
              onClick={() => setShow(true)}
            />
          </Col>
          <Col sm={3}>
            <Form.Control
              type="text"
              placeholder="상세 주소"
              {...register('company_address_detail')}
            />
          </Col>
        </Form.Group>
        {/* <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            정보관리책임자명
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              type="text"
              {...register('company_admin_name')}
            />
          </Col>
        </Form.Group> */}
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            정보관리책임자 이메일
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              type="text"
              {...register('company_admin_email')}
            />
          </Col>
        </Form.Group>
        <Row className="justify-content-center pt-5">
          <Button type="submit" variant="primary">
            저장하기
          </Button>
        </Row>
      </Form>
      <Modal
        show={show}
        centered
        backdrop="static"
        onHide={() => setShow(false)}
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>우편번호 및 주소 찾기</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0">
          <DaumPostcode onComplete={handleComplete} autoResize autoClose />
        </Modal.Body>
      </Modal>
    </Tab.Pane>
  );
}

export default CompanyInfo;
